module.exports = ".modal.active {\n  display: block; }\n\n::ng-deep .phone .modal.active {\n  top: 100px; }\n\nlabel {\n  font-size: 1.6rem;\n  color: black; }\n\nsmall {\n  color: gray; }\n\n.btn-group {\n  margin-right: 5px; }\n  .btn-group button.btn-default {\n    font-size: 1.1rem;\n    border-radius: 3px; }\n  .btn-group-sm .btn {\n    padding: 4px 8px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/angular-framework-client-components/components/video-embed/video-embed-share.style.scss
// module id = 828
// module chunks = 2